import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PowerPointFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PowerPointFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.22 10.56h-.03a2 2 0 0 0-.12-.35v-.07a1.8 1.8 0 0 0-.22-.3l-7.53-7.5c-.09-.09-.18-.16-.28-.22h-.08q-.15-.075-.33-.12H9.01c-2.32 0-4.2 1.87-4.23 4.17v20.09c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74zm-2.84 15.7c0 .77-.76.97-1.4.97H9c-.64 0-1.4-.17-1.4-.97V6.17c0-.78.63-1.4 1.4-1.4h7.94v5.14c0 1.29 1.04 2.34 2.34 2.34h5.1v14.02Zm-8.05-11.83c1.01-.07 2.01.22 2.82.83.68.6 1.04 1.49.98 2.39 0 .63-.16 1.26-.49 1.79s-.81.95-1.37 1.22c-.65.3-1.35.45-2.07.44h-1.96v3.64h-2.01V14.43zm-2.08 5.09h1.73c.55.04 1.09-.13 1.53-.46.36-.35.55-.84.52-1.33 0-1.14-.66-1.7-1.98-1.7h-1.79v3.5Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14H19a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM22.43 20.35h3.91c1.74 0 2.97 1.25 2.97 3s-1.24 3.03-2.97 3.03h-1.62v2.91h-2.28v-8.94Zm4.54 3.01c0-.65-.41-1.14-1.16-1.14h-1.1v2.26h1.1c.75 0 1.16-.47 1.16-1.12"
      })]
    })
  }));
};
PowerPointFileIcon.displayName = 'PowerPointFileIcon';